import React, { useContext, useRef, useState } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getConfiguration } from '../../data/utils/configuration';
import { getCurrencySymbol } from '../../data/utils/getCurrencySymbol';
import { getLocaleDotRound } from '../../data/utils/getLocaleDotRound';
import { getPrintableAmount } from '../../data/utils/getPrintableAmount';
import { getValidAmountString } from '../../data/utils/getValidAmountString';
import { getAmountInCent } from '../../data/utils/getAmountInCent';
import { labels } from '../../data/labels';
import Keypad from './Keypad';

function SystemTuples(props) {
	const betslipContext = useContext(BetslipContext);

    const [showKeypad, setShowKeypad] = useState(false);
    const [showCombKeypad, setShowCombKeypad] = useState(false);
    const [showSplitAmountKeypad, setShowSplitAmountKeypad] = useState(false);
    const selectedIndex = useRef(null);

    function toggleKeypad() {
    	const newValue = !showKeypad;
        setShowKeypad(newValue);
        betslipContext.setKeypadShown(newValue);
    }

    function closeKeypad() {
        setShowKeypad(false);
        betslipContext.setKeypadShown(false);
    }
    
    function toggleCombKeypad(index) {
        selectedIndex.current = index;
        setShowCombKeypad(!showCombKeypad);
    }
    
    function closeCombKeypad() {
        setShowCombKeypad(false);
    }
    
    function toggleSplitAmountKeypad(index) {
        selectedIndex.current = index;
        setShowSplitAmountKeypad(!showSplitAmountKeypad);
    }
    
    function closeSplitAmountKeypad() {
        setShowSplitAmountKeypad(false);
    }

    let betslipData = betslipContext.getBetslipData();
    let conf = getConfiguration();
	let mult = conf.cs.m;
	let charDecimalBrowser = getLocaleDotRound().round;
	const couponKey = props.couponKey;
	const container = props.container;
	const coupon = betslipData.coupons[couponKey];
    let userSystemSelections = coupon.userSystemSelections;
    let combinations = coupon.calculatedSystemData.comb;
   
    if (combinations == null) {
    	combinations = [];
    }
    
    function getFormattedAmount(centAmount) {
    	return getPrintableAmount(centAmount, conf.cs.m, conf.cs.nd);
    }
    
    function toggleCombs(indexComb) {
    	userSystemSelections[indexComb].selected = !userSystemSelections[indexComb].selected;
    	if (coupon.betOnAllEnabled) {
    		coupon.betOnAllEnabled = false;
    	}
      	if(userSystemSelections[indexComb].selected && userSystemSelections[indexComb].amount === 0){
      		// restore the minimum
      		const amountCentToSet = betslipContext.minimumCombAmount;
      		userSystemSelections[indexComb].printableAmount = getFormattedAmount(amountCentToSet);
      		userSystemSelections[indexComb].amount = amountCentToSet;
      	}
    	betslipContext.setBetslipData(betslipData, true);
    }
    
    function toggleBetOnAll() {
    	coupon.betOnAllEnabled = !coupon.betOnAllEnabled;
    	if (!coupon.betOnAllEnabled) {
    		// I disable all the combs: I can't do it in the BetslipConf because there is  no chance to know
    		// if the bet on all is just disabled or has been requested from the user to deactivate everything
    		for (let k in userSystemSelections) {
    			userSystemSelections[k].selected = false;
    		}
    		
    	}
    	betslipContext.setBetslipData(betslipData, true);
    }
    
    function setAmountBetOnAll(settedAmount) {
 	   // get a valid input field value for this amount: only number and dot, and max nDec digit after it
 	   settedAmount = getValidAmountString(settedAmount);
 	   // putting the "browser decimal dot" instead of the "." for the float type
 	   let fieldTextValue = settedAmount;
 	   fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
 	   let amountCentToSet = coupon.betOnAll; // last valid amount
 	   
 	   // if is number, I calculate the new amount and I keep it into the field value. 
 	   // If not, I keep the field but I use the last valid amount for the calcs
 	   if (!isNaN(settedAmount) && settedAmount.length > 0) {
 		   amountCentToSet = getAmountInCent(parseFloat(settedAmount), mult);
 	   }
 	   
 	   coupon.printableBetOnAll = fieldTextValue;
 	   coupon.betOnAll = amountCentToSet;
 	   betslipContext.setBetslipData(betslipData, true);
 	}
    
    function setAmountCombs(indexCombs, settedAmount) {
    	coupon.betOnAllEnabled = false; // deactivate bet on all
    	
    	// get a valid input field value for this amount: only number and dot, and max nDec digit after it
  	   settedAmount = getValidAmountString(settedAmount);
  	   // putting the "browser decimal dot" instead of the "." for the float type
  	   let fieldTextValue = settedAmount;
  	   fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
  	   let amountCentToSet = userSystemSelections[indexCombs].amount; // last valid amount
  	   
  	   // if is number, I calculate the new amount and I keep it into the field value. 
  	   // If not, I keep the field but I use the last valid amount for the calcs
  	   if (!isNaN(settedAmount) && settedAmount.length > 0) {
  		   amountCentToSet = getAmountInCent(parseFloat(settedAmount), mult);
  	   }
  	   
  	   userSystemSelections[indexCombs].printableAmount = fieldTextValue;
  	   userSystemSelections[indexCombs].amount = amountCentToSet;
  	   betslipContext.setBetslipData(betslipData, true);
    }

    function splitAmountCombs(amount) {
    	// get a valid input field value for this amount: only number and dot, and max nDec digit after it
    	amount = getValidAmountString(amount);
   	   // putting the "browser decimal dot" instead of the "." for the float type
   	   let fieldTextValue = amount;
   	   fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
   	   
   	   let amountCentToSet = 0;
   	   // if is number, I calculate the new amount and I keep it into the field value. 
   	   // If not, I keep the field but I use the last valid amount for the calcs
   	   if (isNaN(amount) === false && amount.length > 0) {
   		   amountCentToSet = getAmountInCent(parseFloat(amount), mult);
   		   let totalCombsSelected = 0;
		   for (let ks in userSystemSelections) {
			   if (userSystemSelections[ks].selected) {
				   if (combinations[ks] != null) {
					   totalCombsSelected += combinations[ks];
				   }
			   }
		   }
		   if (totalCombsSelected > 0) {
			   let valuePerTuple = amountCentToSet / totalCombsSelected;
			   valuePerTuple = parseInt(Math.ceil(valuePerTuple));
			   let module = valuePerTuple % conf.cs.imcqf;
			   if(valuePerTuple < conf.cs.imcqf ){
				   valuePerTuple = conf.cs.imcqf;				   
			   }
			   else if(module != 0){
				  const rest = (valuePerTuple / conf.cs.imcqf) % 1 == 0? 0 : (valuePerTuple % conf.cs.imcqf);
				  valuePerTuple  = valuePerTuple - rest;
				  valuePerTuple = parseInt(valuePerTuple);
				  if(valuePerTuple < conf.cs.imcqf){
					  valuePerTuple = conf.cs.imcqf;
				  }  
			   }
			   for(let ks in userSystemSelections) {
				   if (userSystemSelections[ks].selected) {
					   userSystemSelections[ks].printableAmount = getFormattedAmount(valuePerTuple);
					   userSystemSelections[ks].amount = valuePerTuple;
				   }
			   }   
 		   }
   	   }
   	   coupon.printableSplitAmount = fieldTextValue;
   	   betslipContext.setBetslipData(betslipData, true);
    }

    const currency = getCurrencySymbol(conf.cs.ct);
    let atLeastOneTuple = false;
    for (let key in userSystemSelections) {
        if (userSystemSelections[key].selected) {
            atLeastOneTuple = true;
    		break;
    	}
    }
    const stakeTaxedForPurchase = betslipContext.stakeTaxConfiguration.enabled && 
	  							  betslipContext.stakeTaxConfiguration.type === 'conf_for_purchase';
    
    return (
        <>
            <div className="evento-schedina">
                <div className="schedina-scomm-checker">
                    <div className="custom-control custom-checkbox">
                        <input type="checkbox"
                                className="custom-control-input"
                                id="bet-on-all-coupon-1-container-systembets-checkbox"
                                checked={coupon.betOnAllEnabled}
                                onChange={(e) => toggleBetOnAll()} />
                        <label className="custom-control-label pointer" htmlFor="bet-on-all-coupon-1-container-systembets-checkbox">{labels['betslip.system_bets.bet_on_all']}</label>
                    </div>
                    <div className="input-puntata_bottone">
                        <button disabled={!coupon.betOnAllEnabled} onClick={toggleKeypad}>{coupon.printableBetOnAll}</button>
                        {showKeypad &&
                            <Keypad amount={coupon.printableBetOnAll}
                                    currency={currency}
                                    decimalsEnabled={true}
                                    decimalSeparator={charDecimalBrowser}
                                    setAmount={a => setAmountBetOnAll(a + '')}
                                    close={closeKeypad} />
                        }
                    </div>
                </div>
                <div className="tabella-puntate-sistema">
                    <div className="titolo-tps bg-grigio-chiaro">{labels['betslip.system_bets.grp']}</div>
                    <div className="titolo-tps bg-grigio-chiaro"></div>
                    <div className="titolo-tps bg-grigio-chiaro">{labels['betslip.system_bets.com']}</div>
                    <div className="titolo-tps bg-grigio-chiaro">{labels['betslip.system_bets.amount']}</div>
                    <div className="titolo-tps bg-grigio-chiaro">{labels['betslip.system_bets.winnings']}</div>
                    {combinations.map(function(combination, index) {
                        let reactCombKey = 'system-tuples-coupon-' + couponKey + '-container-' + container + "-tuple-" + index;
                        let idInputCheckbox = reactCombKey + "-checkbox";
                        if (combination > 0) {
                            return (
                                <React.Fragment key={reactCombKey}>
                                    <div className="campo-tps">{index}</div>
                                    <div className="campo-tps">
                                        <div className="custom-control custom-checkbox">
                                            <input checked={userSystemSelections[index].selected} onChange={() => toggleCombs(index)} type="checkbox" className="custom-control-input" id={idInputCheckbox} />
                                            <label className="custom-control-label pointer" htmlFor={idInputCheckbox}></label>
                                        </div>
                                    </div>
                                    <div className="campo-tps">{combination}</div>
                                    <div className="campo-tps"> 
                                        <div className="input-puntata_bottone">
                                            <button onClick={() => toggleCombKeypad(index)}>{userSystemSelections[index].printableAmount}</button>
                                            {showCombKeypad && selectedIndex.current === index &&
                                                <Keypad amount={userSystemSelections[selectedIndex.current].printableAmount}
                                                        currency={currency}
                                                        decimalsEnabled={true}
                                                        decimalSeparator={charDecimalBrowser}
                                                        setAmount={a => setAmountCombs(selectedIndex.current, a + '')}
                                                        close={closeCombKeypad} />
                                            }
                                        </div>
                                    </div>
                                    <div className="campo-tps">
	 		        					{getFormattedAmount(userSystemSelections[index].vMin)} 
	 		        					<br/> 
	 		        					{getFormattedAmount(userSystemSelections[index].vMax)}
                                    </div>
                                </React.Fragment>
                            )
                        }
                        return null;
                    })}
                </div>
                <div className="schedina-suddividi-puntata">
                    <div className="schedina-suddividi-puntata-testo">
                        <p>{labels['betslip.system_bets.split_bet']}</p>
                    </div>
                    <div className="input-puntata_bottone">
                        <button disabled={!atLeastOneTuple} onClick={toggleSplitAmountKeypad}>{coupon.printableSplitAmount} {currency}</button>
                        {showSplitAmountKeypad &&
                            <Keypad amount={coupon.printableSplitAmount}
                                    currency={currency}
                                    decimalsEnabled={true}
                                    decimalSeparator={charDecimalBrowser}
                                    setAmount={a => splitAmountCombs(a + '')}
                                    close={closeSplitAmountKeypad} />
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default SystemTuples;